<template>
  <div class="center pad-bottom20">
    <div class="nav">
      <ul>
        <li><router-link :to="'/'">首页</router-link></li>
        <li>
          <router-link :to="'/list'" class="current">新闻公告</router-link>
        </li>
        <li><router-link :to="'/jobfair'">现场招聘</router-link></li>
        <li>
          <router-link :to="'/subject'">网络招聘会</router-link>
        </li>
        <li>
          <router-link :to="'/guidance'">办事指南</router-link>
        </li>
      </ul>
    </div>
    <div v-if="param">
      <el-container>
        <el-header class="box">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
              <router-link :to="'/'">首页</router-link>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <router-link :to="'list'" class="current">新闻列表</router-link>
            </el-breadcrumb-item>
            <el-breadcrumb-item
              ><span>{{ news.title }}</span></el-breadcrumb-item
            >
          </el-breadcrumb>
        </el-header>
      </el-container>
      <div class="biaoTi2">
        <p>{{ news.title }}</p>
        <table>
          <tr>
            <td>
              发布时间：<span>{{ news.addtime }}</span>
            </td>
            <td>
              来源：<span
                ><a href="https://www.scrc168.com" target="_blank"
                  >四川人才网</a
                ></span
              >
            </td>
          </tr>
        </table>
      </div>
      <div class="mainBody width-1160 padding-20 wenZhang positionR">
        <div class="content" v-html="news.content"></div>
        <div class="bottom-btn-area">
          <div class="flex justify-center align-center padding-20">
            <el-button type="primary" @click="readOriginal(news.guid)">
              <span>阅读原文</span>
            </el-button>
            <el-button type="primary" @click="$router.push({ path: '/list' }, onComplete => { }, onAbort => { })">
              <span>关闭窗口</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { UTCtoBeiJing } from '@/utils/formatter'
export default {
  data() {
    return {
      param: null,
      news: {},
    }
  },
  created() {
    this.initDetail()
  },
  filters: {
    resourceURL: function (strHtml) {
      return strHtml
    },
  },
  methods: {
    initDetail() {
      this.param = {
        type: this.$route.query.newstype,
        id: this.$route.query.id
      }
      // console.log(this.param)
      let that = this
      request
        .post('/news/detail', { id: this.param.id, type: this.param.type })
        .then((response) => {
          if (response.data.code === 200) {
            let source = Object.assign({}, response.data.data)
            // source.addtime = that.formatDate(UTCtoBeiJing(source.addtime))
            // console.log(source.content)
            source.content = that.formatURL(source.content)
            that.news = source
          }
        })
        .catch((err) => {
          console.log(err)
          this.$msgbox({
            title: '系统提示',
            message: '该新闻不存在',
            type: 'error',
            callback: (action, instance) => {
              that.$router.push({
                path: '/list',
              })
            },
          })
        })
    },
    formatDate(date) {
      const mistime = new Date() - new Date(date)
      if (mistime > 0 && mistime <= 1000 * 60 * 60 * 6) {
        return '刚刚'
      } else if (
        mistime > 1000 * 60 * 60 * 6 &&
        mistime <= 1000 * 60 * 60 * 24
      ) {
        return Math.floor(mistime / 1000 / 60 / 60) + '小时前'
      } else if (
        mistime > 1000 * 60 * 60 * 24 &&
        mistime <= 1000 * 60 * 60 * 24 * 20
      ) {
        return Math.floor(mistime / 1000 / 60 / 60 / 24) + '天前'
      } else {
        return (
          new Date(date).getFullYear() +
          '年' +
          (new Date(date).getMonth() + 1) +
          '月' +
          new Date(date).getDate() +
          '日'
        )
      }
    },
    formatURL(str) {
      const newHtml = str
        .replace(
          /<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
          function (match, capture) {
            if (match.indexOf('www.scrc168.com') === -1 && match.indexOf('base64') === -1) {
              match =
                match.slice(0, match.indexOf(capture)) +
                'https://www.scrc168.com' +
                match.slice(match.indexOf(capture))
            }
            match =
              match.slice(0, match.lastIndexOf('/>')) +
              'style="max-width: 100%;" />'
            return match
          }
        )
        .replace(
          /<a [^>]*href=['"]([^'"]+)[^>]*>/gi,
          function (match, capture) {
            if (match.indexOf('href="https://www.scrc168.com') === -1) {
              match =
                match.slice(0, match.indexOf(capture)) +
                'https://www.scrc168.com' +
                match.slice(match.indexOf(capture))
            }
            return match
          }
        )
      return newHtml
    },
    readOriginal(guid) {
      window.open(
        'https://www.scrc168.com/WebSite/UI_1Home/NewsInfo?index=0&Guid=' + guid
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('../../styles/main.scss');
@import url('../../../static/originals/css/siChuan.css');
div {
  margin: 0 auto;
  font-size: 14px;
}
.box {
  padding: 20px;
  color: #000000;
  list-style: none;
}
</style>
<style lang="scss">
.el-menu {
  border-right: none;
}

.el-pagination {
  span,
  button {
    height: 28px !important;
    line-height: 28px !important;
  }
}

.el-pager {
  li {
    height: 28px !important;
    line-height: 28px !important;
    border-bottom: none !important;
    width: 28px !important;
    margin: 0 5px;
    background: #f4f4f5 !important;
  }

  li:hover {
    border-bottom: none !important;
    background: none !important;
  }
}

.wenZhang {
  min-height: 300px;
}

.bottom-btn-area {
  position: absolute !important;
  height: 60px !important;
  width: inherit !important;
  bottom: 0;
}

.bottom-btn-area {
  height: inherit !important;
  width: inherit !important;
}

.content {
  display: block;
  position: relative;
  height: auto !important;
  margin: auto auto 80px auto !important;
  width: 100% !important;

  p {
    line-height: 2rem;
    text-indent: 0;
    color: #000;
  }

  a {
    line-height: 2rem;
    text-indent: 0;
    color: #0000ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/list/detail.vue